import styled from "styled-components";

export const Wrapper = styled.div`
    
`;

export const Top = styled.div`
    border-bottom: 0.0625rem solid ${({ theme }) => theme.color.light};
`;

export const ProductGallery = styled.div`
    position: relative;
`;

export const Discount = styled.div`
    height: 46px;
    width: 46px;
    border-radius: 100px;
    border: 0.0938rem dashed ${({ theme }) => theme.color.blue};
    background-color: ${({ theme }) => theme.color.red};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 5;
`;

const DiscountExtends = styled.div`
    line-height: 1;
    color: ${({ theme }) => theme.color.white};
    font-size: 0.75rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};

`;

export const DiscountValue = styled(DiscountExtends)`

`;

export const OffText = styled(DiscountExtends)`
    text-transform: uppercase;
    font-size: 0.4375rem;
`;

export const Informations = styled.div`
    background-color: ${({ theme }) => theme.color.white};
    border-top-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    margin-top: -35px;
    padding-top: 15px;
    padding-bottom: 30px;
    overflow: hidden;
    position: relative;
    z-index: 99;
    -webkit-box-shadow: 0 -4px 10px 2px rgba(150, 150, 150, 0.1);
    box-shadow: 0 -4px 10px 2px rgba(150, 150, 150, 0.1);
`;

export const LikeArea = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    button {
        &:last-child {
            margin-left: 10px;
        }
    }
`;

export const StoreTitle = styled.span`
    font-size: 0.8125rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw600};
    color: ${({ theme }) => theme.color.gray};
    display: block;
    margin-bottom: 0.5rem;
`;

export const ProductTitle = styled.h1`
    font-size: 1rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${({ theme }) => theme.color.black};
    margin-bottom: 0.9375rem;
`;

export const ProductPrice = styled.h2`
    font-size: 1.5rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${props => props.producPriceColor};
    margin-bottom: 1.25rem;
`;

export const WrappBuyButton = styled.div`
    text-align: center;

    button {
        max-width: 460px !important;
    }
`;

export const LikeButton = styled.button`
    background-color: ${props => props.activeBackground ? props.activeBackground : "#FFFFFF"};
    border: 0;
    /* padding: 0.75rem 0.75rem 0.75rem 0.75rem; */
    border: 1px solid ${({ theme }) => theme.color.light};
    border-radius: 100%;
    min-width: 40px;
    height: 40px;
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {

        height: 16px;
        width: auto !important;
        transform: rotate(${props => props.buttonType === "deslike" ? "180deg" : "0"});
        path {
            /* fill: ${({ theme }) => theme.color.gray}; */
            fill: ${props => props.activeIconColor ? props.activeIconColor : props.theme.color.gray} ;
        }
    }
`;

export const Bottom = styled.div`
    padding-top: 0.9375rem;
`;

export const Description = styled.div`
    margin-bottom: ${props => props.marginBottom ? `1.875rem` : 0};
`;

export const DescriptionTitle = styled.h1`
    font-size: 0.875rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw700};
    color: ${({ theme }) => theme.color.black};
    margin-bottom: 0.625rem;
`;

export const DescriptionText = styled.p`
    font-size: 0.8125rem;
    font-weight: ${({ theme }) => theme.fontWeight.fw500};
    color: ${({ theme }) => theme.color.black};
    margin-bottom: 0;
`;

export const RulesAndInformations = styled.div`
    border: 1px solid ${({ theme }) => theme.color.light};
`;

export const AccordionContent = styled.ul`
    width: 100%;

    li {
        &:first-child {
            padding-top: 0;
        }

        &:last-child {
            border-bottom: 0;
        }
    }
`;

export const AccordionContentItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: ${({ theme }) => theme.fontWeight.fw500};
    color: ${({ theme }) => theme.color.black};
    border-bottom: 1px dashed ${({ theme }) => theme.color.light};
    padding: 5px 0;
`;

export const ItemCheck = styled.div`
    margin-right: 0.5rem;
    svg {
        height: 0.8125rem;
        width: auto !important;

        path {
            fill: ${props => props.iconColor ? props.iconColor : '#ccc'};
        }
    }
`;


export const LoadMoreButton = styled.button`
    color: ${props => props.textColor ? props.textColor : '#ccc'};
    border: 0;
    background-color: transparent;
    margin-top: .25rem;
`;

export const StoreListItem = styled.li`
    margin-bottom: 4px;
    display: flex;
    align-items: center;

    svg {
        height: 5px;
        width: auto !important;
        margin-right: 4px;

        path {
            fill: ${({ theme }) => theme.color.gray};
        }
    }
`;

export const ShowDate = styled.p`
    font-size: .8125rem;
    color: #545d5d;
    margin: .625rem 0;
    
    & > span {
        color: #545d5d;
    }
`